module.exports = __webpack_public_path__ + "static/categoriesRacing-50deaee3a3d013ba22ac66fa58fcc6ae.jpg";